import { api } from 'api'
import { path } from 'ramda'
import { ShiftSimple } from './typings'

export async function getShiftDuplicateRecs() {
  const data = await api.post(
    '/company/graphql_dispatch/shift_duplicate_recommendations_e8aed0ad',
    {}
  )

  const shifts = path(
    ['data', 'data', 'company', 'shiftDuplicateRecommendations'],
    data
  ) as ShiftSimple[]

  return shifts.map((shift) => ({
    ...shift,
    position: shift.position
      ? {
          ...shift.position,
          id: Number(shift.position.id),
        }
      : undefined,
    location: shift.location
      ? {
          ...shift.location,
          id: Number(shift.location.id),
        }
      : undefined,
  }))
}
